export default {
  default: [
    {
      path: "rapportage",
      name: "chartReport",
      component: () => import("./views/ChartReportView.vue"),
      children: [
        {
          name: "report.fundingContractCashflow",
          path: "spaarcontracten-kasstroom",
          component: () => import("./components/reports/FundingContractCashflowReport.vue"),
        },
        {
          name: "report.fundingContractInterest",
          path: "spaarcontracten-rentekosten",
          component: () => import("./components/reports/FundingContractInterestReport.vue"),
        },
        {
          name: "report.activeFunderRatio",
          path: "spaarders-actief-verhouding",
          component: () => import("./components/reports/ActiveFunderRatioReport.vue"),
        },
        {
          name: "report.fundingIn",
          path: "spaarcontracten-in",
          component: () => import("./components/reports/FundingInReport.vue"),
        },
        {
          name: "report.fundingOut",
          path: "spaarcontracten-uit",
          component: () => import("./components/reports/FundingOutReport.vue"),
        },
        {
          name: "report.fundingContractVariantRatio",
          path: "spaarcontracten-variant-verhouding",
          component: () => import("./components/reports/FundingContractVariantRatioReport.vue"),
        },
        {
          name: "report.numberOfFundingContracts",
          path: "aantal-spaarcontracten",
          component: () => import("./components/reports/NumberOfFundingContractsReport.vue"),
        },
        {
          name: "report.averageFunding",
          path: "gemiddelde-inleg",
          component: () => import("./components/reports/AverageFundingReport.vue"),
        },
        {
          name: "report.partnerFee",
          path: "partner-kosten",
          component: () => import("./components/reports/PartnerFeeReport.vue"),
        },
      ],
    },
    {
      path: "rapportage",
      name: "report",
      children: [
        {
          path: "afwijkingen",
          name: "report.fundingContractDeviations",
          component: () => import("./views/DeviationReportView.vue"),
        },
      ],
    },
    {
      path: "rapportages",
      name: "reports.overview",
      component: () => import("./views/ReportOverviewView.vue"),
      redirect: { name: "reports.financial" },
      children: [
        {
          path: "financieel",
          name: "reports.financial",
          component: () => import("./components/reports/FinancialReport.vue"),
        },
      ],
    },
  ],
};
